import React from 'react'
import Container from 'react-bootstrap/Container';
import Row from 'react-bootstrap/Row';
import Image from 'react-bootstrap/Image';
import Col from 'react-bootstrap/Col';
import Socialprint from '../Components/img/Socialprint/socialprint11jpg.jpg'
import Socialprint1 from '../Components/img/Socialprint/socialprint10.jpg'
import Socialprint2 from '../Components/img/Socialprint/socialprint89.jpg'
import Socialprint3 from '../Components/img/Socialprint/socialprint7.jpg'
import Socialprint4 from '../Components/img/Socialprint/socialprint1.jpg'
import Socialprint5 from '../Components/img/Socialprint/socilaprint4.jpg'
import Socialprint6 from '../Components/img/Socialprint/socialprint2.jpg'
import Socialprint7 from '../Components/img/Socialprint/socialprint8.jpg'
import Socialprint8 from '../Components/img/Socialprint/socialprint6.jpg'
import Socialprint9 from '../Components/img/Socialprint/WhatsApp Image 2025-02-22 at 6.04.49 PM.jpeg'
import Socialprint10 from '../Components/img/Socialprint/newprint1.jpeg'
import socialprint11 from '../Components/img/Socialprint/jan.jpeg'

const Print_media = () => {
  return (
    <>
    <Container>
    <Row className='g-2 mb-3' >
    <Col xs={6} md={4} >
          <Image src={Socialprint} rounded />
        </Col>
        <Col xs={6} md={4}>
          <Image src={Socialprint1} rounded />
        </Col>
        <Col xs={6} md={4}>
          <Image src={Socialprint2} rounded />
        </Col>
    </Row>
    <Row className='g-2 mb-3'>
    <Col xs={6} md={4} >
          <Image src={Socialprint9} rounded />
        </Col>
        <Col xs={6} md={4}>
          <Image src={Socialprint10} rounded />
        </Col>
        <Col xs={6} md={4}>
          <Image src={Socialprint5} rounded />
        </Col>
    </Row>
    <Row className='g-2 mb-3'>
    <Col xs={6} md={4} >
          <Image src={Socialprint6} rounded />
        </Col>
        <Col xs={6} md={4}>
          <Image src={Socialprint7} rounded />
        </Col>
        <Col xs={6} md={4}>
          <Image src={Socialprint8} rounded />
        </Col>
    </Row>
    <Row className='g-2 mb-3' >
    <Col xs={6} md={4} >
          <Image src={Socialprint3} rounded />
        </Col>
        <Col xs={6} md={4}>
          <Image src={Socialprint4} rounded />
        </Col>
        <Col xs={6} md={4}>
          <Image src={socialprint11} rounded />
        </Col>
    </Row>
  </Container>
 </>
  )
}

export default Print_media
